import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost";
type Size = "md" | "sm";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  block?: boolean;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  children: ReactNode;
}

// All visual styling (incl. hover/active/focus/disabled) lives in the global stylesheet
// injected by TenantLayout, keyed on these classes — so state styles work despite inline
// styles being used elsewhere in the app. Colours resolve from the brand CSS variables.
export function Button({
  variant = "primary",
  size = "md",
  block = false,
  leadingIcon,
  trailingIcon,
  className,
  children,
  ...rest
}: Props) {
  const classes = [
    "rg-btn",
    `rg-btn--${variant}`,
    `rg-btn--${size}`,
    block ? "rg-btn--block" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classes} {...rest}>
      {leadingIcon}
      <span>{children}</span>
      {trailingIcon}
    </button>
  );
}
